export enum ColKeysEnum {
  replacedContractsRefNumber = 'replacedContractsRefNumber',
  requestLink = 'requestLink',
  nature = 'nature',
  company = 'company',
  customerId = 'customerId',
  costCenter = 'costCenter',
  contract = 'contract',
  distance = 'distance',
  driverName = 'driverName',
  duration = 'duration',
  objectManager = 'objectManager',
  licenceNumber = 'licenceNumber',
  location = 'location',
  price = 'price',
  product = 'product',
  state = 'state',
  vehicle = 'vehicle',
  startDate = 'startDate',
  endDate = 'endDate',
  makes = 'makes',
  model = 'model',
  gallikerReference = 'gallikerReference',
  chassisNumber = 'chassisNumber',
  motorNumber = 'motorNumber',
  requestDelivery = 'requestDelivery',
  entryDate = 'entryDate',
  endIntention = 'endIntention',
  orderStatus = 'orderStatus',
  returnProposed = 'returnProposed',
  returnScheduled = 'returnScheduled',
  returnDate = 'returnDate',
  returnProtocol = 'returnProtocol',
  returnDocument = 'returnDocument',
  finalCalculation = 'finalCalculation',
  imposedReturnDate = 'imposedReturnDate',
  Administration = 'administration',
  Unit = 'unit',
}
